module.exports = __webpack_public_path__ + "static/media/arrow-down.f9261bd2.svg";